//import {pagination} from "./state"
const mutations = {
    setListDataItem: (state, payload) => {
        state.listDataItem = payload
    },

    updateListItem: (state, payload) => {
        let data = state.listDataItem.actual
        data.push(...payload.actual)
    },
}

export default mutations